if (!customElements.get('sugar-scrub-purchase')) {
  customElements.define('sugar-scrub-purchase', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('[data-scrub-form]');
      if (!this.form) return;
      this.quantity = this.form.querySelector('[name="quantity"]');
      this.form.addEventListener('change', event => {
        if (event.target.name === 'id') this.updateSelection(true);
      });
      this.form.addEventListener('click', event => {
        const button = event.target.closest('[data-quantity-step]');
        if (!button) return;
        const step = Number(this.quantity.step) || 1;
        const min = Number(this.quantity.min) || 1;
        const max = Number(this.quantity.max) || Infinity;
        this.quantity.value = Math.min(max, Math.max(min, (Number(this.quantity.value) || min) + step * Number(button.dataset.quantityStep)));
        this.updateQuantityButtons();
      });
      this.quantity.addEventListener('input', () => this.updateQuantityButtons());
      this.form.addEventListener('submit', event => {
        const selected = this.form.querySelector('[name="id"]:checked');
        if (!selected || selected.dataset.available !== 'true') event.preventDefault();
      });
      this.restoreSelection();
      this.onHistoryChange = () => {
        this.restoreSelection();
        this.updateSelection(false);
      };
      window.addEventListener('popstate', this.onHistoryChange);
      this.updateSelection(false);
    }

    disconnectedCallback() {
      window.removeEventListener('popstate', this.onHistoryChange);
    }

    restoreSelection() {
      const url = new URL(window.location.href);
      const id = url.searchParams.get('group_variant') || url.hash.match(/^#choice=(\d+)$/)?.[1] || url.searchParams.get('variant');
      const inputs = Array.from(this.form.querySelectorAll('[name="id"]'));
      let selected = inputs.find(input => input.value === id);
      if (!selected && (url.hash === '#combo' || url.hash === '#set-of-7')) {
        selected = this.form.querySelector('[data-linked-combo]');
      }
      if (selected) selected.checked = true;
    }

    updateSelection(updateUrl) {
      const selected = this.form.querySelector('[name="id"]:checked');
      if (!selected) return;
      const available = selected.dataset.available === 'true';
      this.querySelector('[data-purchase-price]').textContent = selected.dataset.money;
      this.querySelector('[data-purchase-selection]').textContent = selected.dataset.title;
      const stock = this.querySelector('[data-purchase-stock]');
      const stockTemplate = Array.from(this.querySelectorAll('template[data-group-stock]')).find(item => item.dataset.groupStock === selected.value);
      if (stockTemplate) stock.replaceChildren(stockTemplate.content.cloneNode(true));
      else stock.textContent = available ? this.dataset.inStock : this.dataset.outOfStock;
      stock.toggleAttribute('data-sold-out', !available);
      const submit = this.querySelector('[data-purchase-submit]');
      submit.disabled = !available;
      submit.textContent = available ? this.dataset.addLabel : this.dataset.soldLabel;
      const min = Number(selected.dataset.min) || 1;
      const step = Number(selected.dataset.step) || 1;
      const max = selected.dataset.max === '' || selected.dataset.max === undefined ? Infinity : Number(selected.dataset.max);
      this.quantity.min = min;
      this.quantity.step = step;
      if (Number.isFinite(max)) this.quantity.max = Math.max(min, max);
      else this.quantity.removeAttribute('max');
      const value = Number(this.quantity.value) || min;
      this.quantity.value = Math.max(min, Math.min(max, min + Math.max(0, Math.floor((value - min) / step)) * step));
      this.quantity.disabled = !available;
      this.updateQuantityButtons();
      this.updateSelectedImage(selected);
      if (updateUrl && this.closest('product-info')?.dataset.updateUrl !== 'false') {
        const url = new URL(window.location.href);
        url.pathname = this.dataset.baseUrl;
        url.searchParams.delete('group_variant');
        if (selected.hasAttribute('data-linked-combo')) {
          url.searchParams.delete('variant');
          url.searchParams.set('group_variant', selected.value);
        } else {
          url.searchParams.set('variant', selected.value);
        }
        url.hash = '';
        window.history.replaceState({}, '', url);
      }
    }

    updateSelectedImage(selected) {
      const wrapper = this.closest('product-info')?.querySelector('.product__media-wrapper');
      if (!wrapper) return;
      const foreign = selected.dataset.productId !== this.dataset.baseProduct;
      const template = Array.from(this.querySelectorAll('template[data-group-gallery]')).find(item => item.dataset.groupGallery === selected.dataset.productId);
      if (foreign && this.galleryProduct !== selected.dataset.productId) {
        this.groupGallery?.remove();
        this.groupGallery = template?.content.firstElementChild.cloneNode(true);
        if (!this.groupGallery && selected.dataset.image) {
          this.groupGallery = document.createElement('div');
          const image = document.createElement('img');
          image.dataset.groupPreview = '';
          image.className = 'blocks-radius';
          image.style.cssText = 'width:100%;height:auto;aspect-ratio:1;object-fit:contain;display:block';
          image.src = selected.dataset.image;
          image.alt = selected.dataset.title;
          this.groupGallery.append(image);
        }
        if (this.groupGallery) {
          wrapper.append(this.groupGallery);
        }
        this.galleryProduct = selected.dataset.productId;
      }
      const showGallery = foreign && Boolean(this.groupGallery);
      if (this.groupGallery) {
        this.groupGallery.hidden = !showGallery;
        this.groupGallery.style.display = showGallery ? 'block' : 'none';
        const image = this.groupGallery.querySelector('[data-group-preview]');
        if (image) image.style.display = showGallery ? 'block' : 'none';
      }
      const productLayout = wrapper.closest('.product');
      if (productLayout) {
        if (!this.baseMediaClasses) this.baseMediaClasses = Array.from(productLayout.classList).filter(name => name.startsWith('product--media-has-') || name === 'product--odd-media');
        Array.from(productLayout.classList).filter(name => name.startsWith('product--media-has-') || name === 'product--odd-media').forEach(name => productLayout.classList.remove(name));
        if (showGallery) {
          const count = Number(this.groupGallery.dataset.mediaCount) || 1;
          productLayout.classList.add(`product--media-has-${count}`);
          productLayout.classList.toggle('product--media-has-many', count > 1);
          productLayout.classList.toggle('product--odd-media', productLayout.classList.contains('product--grid-mix') && count % 3 === 2);
        } else {
          this.baseMediaClasses.forEach(name => productLayout.classList.add(name));
        }
      }
      Array.from(wrapper.children).forEach(child => {
        if (child === this.groupGallery) return;
        if (showGallery && !child.hasAttribute('data-group-original-hidden')) {
          child.dataset.groupOriginalHidden = String(child.hidden);
          child.dataset.groupOriginalDisplay = child.style.getPropertyValue('display');
          child.dataset.groupOriginalPriority = child.style.getPropertyPriority('display');
          child.hidden = true;
          child.style.setProperty('display', 'none', 'important');
        } else if (!showGallery && child.hasAttribute('data-group-original-hidden')) {
          child.hidden = child.dataset.groupOriginalHidden === 'true';
          if (child.dataset.groupOriginalDisplay) child.style.setProperty('display', child.dataset.groupOriginalDisplay, child.dataset.groupOriginalPriority);
          else child.style.removeProperty('display');
          delete child.dataset.groupOriginalHidden;
          delete child.dataset.groupOriginalDisplay;
          delete child.dataset.groupOriginalPriority;
        }
      });
    }

    updateQuantityButtons() {
      this.querySelector('[data-quantity-step="-1"]').disabled = this.quantity.disabled || Number(this.quantity.value) <= Number(this.quantity.min || 1);
      this.querySelector('[data-quantity-step="1"]').disabled = this.quantity.disabled || Boolean(this.quantity.max) && Number(this.quantity.value) >= Number(this.quantity.max);
    }
  });
}
